import React from "react";

const ChatBubbleIcon = ({
  size = 24,
  ...props
}: React.SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M26.7378 22.1605C28.3516 19.369 28.894 16.0854 28.2635 12.9233C27.6331 9.76109 25.873 6.93659 23.312 4.97741C20.7511 3.01824 17.5645 2.05839 14.3475 2.27719C11.1306 2.49599 8.10329 3.87847 5.83122 6.16636C3.55915 8.45426 2.19771 11.4911 2.00124 14.7095C1.80477 17.9279 2.7867 21.1077 4.76361 23.655C6.74051 26.2023 9.57716 27.9427 12.7436 28.5512C15.9101 29.1597 19.1898 28.5946 21.97 26.9615L28.5228 28.7903L26.7378 22.1605Z"
      stroke="currentColor"
      strokeWidth="2.65617"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatBubbleIcon;
